import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import CheckCircle from '@/images/CheckCircle.svg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';

const BlueContainer = styled.div`
    display: flex;
    background-color: #ddf1ff;
    border-radius: 10px;
    padding: 16px;
    width: 100%;

    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.32px;
    gap: 16px;
`;

const Col = styled.div`
    :nth-child(2) {
        margin-left: auto;
        min-width: 50%;
    }
`;

const Row = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    white-space: pre-wrap;
    padding: 8px 0;
`;

export const VideoHelper = () => {
    const theme = useTheme();

    return (
        <BlueContainer>
            <Col>
                <Row>
                    <MaskedIcon src={CheckCircle} size="16px" color={theme.colors.links.main} />
                    <span>
                        Keep your <strong>face visible</strong> at all times
                    </span>
                </Row>
                <Row>
                    <MaskedIcon src={CheckCircle} size="16px" color={theme.colors.links.main} />
                    <span>
                        Look directly <strong>into the camera</strong>
                    </span>
                </Row>
            </Col>
            <Col>
                <Row>
                    <MaskedIcon src={CheckCircle} size="16px" color={theme.colors.links.main} />
                    <span>
                        Record yourself speaking in a <strong>quiet, well lit environment</strong>
                    </span>
                </Row>
                <Row>
                    <MaskedIcon src={CheckCircle} size="16px" color={theme.colors.links.main} />
                    <span>
                        Make sure to <strong>pause between sentences</strong> with your <strong>mouth closed</strong>
                    </span>
                </Row>
            </Col>
        </BlueContainer>
    );
};
